<div class="wf-hotkeys-info-container">
  <nav>
    @for (category of categoryNavigationArray; track category.key) {
      <button
        class="wf-hotkeys-info-button"
        [class.wf-hotkeys-info-button--active]="
          activeCategory()?.key === category.key
        "
        wui-button
        type="button"
        size="xxs"
        (click)="activeCategory.set(category)"
      >
        <wf-icon
          [iconName]="category.icon"
          textClass="wf-hotkeys-info-button-text"
          iconClass="wf-hotkeys-info-button-icon"
          [text]="category.title | translate"
        />
      </button>
    }
  </nav>
</div>

<div class="wf-hotkeys-info__content">
  @if (activeCategory()?.key) {
    <span class="wf-text-xl-demibold">
      {{ activeCategory().title | translate }}
    </span>

    <span class="wf-text-sm-regular wf-hotkeys-info__description">
      {{ activeCategory().description | translate }}
    </span>

    <hr class="wf-hotkeys-info__divider" />

    <div class="wf-hotkeys-info__content-list">
      @for (
        hotkey of registeredHotkeysByCategory()[activeCategory().key];
        track trackByCategoryNavigationItem(idx, hotkey);
        let idx = $index
      ) {
        <div class="wf-hotkeys-info__content-list-item">
          <span class="wf-text-sm-medium">
            {{ 'HOTKEYS.' + hotkey.command | translate }}
          </span>

          <div
            class="wf-text-sm-regular wf-hotkeys-info__content-list-item-hint"
          >
            @for (key of hotkey.hint | getKeysFromHint; track key) {
              <div class="key-display">
                {{ key }}
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
